import Scrollbar from 'smooth-scrollbar';

/*
 ractive-decorators-selectric
 =============================================
 Integrate Ractive with selectric
 */
var selectricDecorator = function (node, content) {
    var ractive = node._ractive.proxy.ractive;
    var setting = false;
    var observer;
    var scrollbar;

    // Push changes from ractive to selectric
    if (node._ractive.proxy.binding) {
        observer = ractive.observe(node._ractive.proxy.binding.model.keypath, function (newvalue) {

            if (!setting) {
                setting = true;
                window.setTimeout(function () {
                    if (newvalue === "") {
                        $(node).prop('selectedIndex', 0);
                    }

                    $(node).selectric('refresh');
                    // scrollbar.update();
                    setting = false;
                }, 0);
            }
        });
    }

    // Pull changes from selectric to ractive
    $(node).selectric({
        /*
         * Type: String [HTML]
         * Description: Markup for open options button
         */
        onChange         : function () {
            if (!setting) {
                setting = true;
                ractive.updateModel();
                setting = false;
            }
        },
        onOpen           : function () {
            scrollbar = Scrollbar.init(
                $(node)
                    .parents('.selectric-wrapper')
                    .find('.selectric-scroll')
                    .get(0)
            );
        },
        onClose          : function () {
            scrollbar.destroy();
        }
    });

    return {
        update  : function (args) {
            setting = true;
            window.setTimeout(function () {
                $(node).selectric('refresh');
                setting = false;
            }, 0);
        },
        teardown: function () {
            $(node).selectric('destroy');

            if (observer) {
                observer.cancel();
            }
        }
    };
};

export {selectricDecorator};
